export default {
  slidesPerView: 2.5,
}